import React, { useContext, useEffect, useState } from 'react';
import { ScheduleMeeting } from 'react-schedule-meeting';
import { styles } from './Styles';
import DebugService from '../../services/DebugService';
import { AppContext } from '../../state/AppContext';

export default function MeetingScheduler(props) {
  // this generates basic available timeslots for the next 6 days
  // const defaultAvailableTimeslots = [0, 1, 2, 3, 4, 5, 6].map((id) => {
  //   return {
  //     id,
  //     startTime: new Date(new Date(new Date().setDate(new Date().getDate() + id)).setHours(11, 0, 0, 0)),
  //     endTime: new Date(new Date(new Date().setDate(new Date().getDate() + id)).setHours(17, 0, 0, 0)),
  //   };
  // });
  const defaultAvailableTimeslots = []

  const [availableTimeSlots, setAvailableTimeSlots] = useState(defaultAvailableTimeslots)

  const {refresh, setRefresh} = useContext(AppContext)
  
  // const availableTimeslots2 = [
  //   {
  //     startTime: new Date('2024-02-05 11:00'),
  //     endTime: new Date('2024-02-05 11:30')
  //   },
  //   {
  //     startTime: new Date('2024-02-05 16:00'),
  //     endTime: new Date('2024-02-05 16:30')
  //   },
  //   {
  //     startTime: new Date('2024-02-06 10:00'),
  //     endTime: new Date('2024-02-06 10:30')
  //   },
  //   {
  //     startTime: new Date('2024-02-06 15:00'),
  //     endTime: new Date('2024-02-06 15:30')
  //   },
  // ]

  DebugService.log('MeetingScheduler Component: Available Time Slots', availableTimeSlots)

  useEffect(() => {
    DebugService.log('MeetingScheduler Component: Available Time slots via props', props['availableTimeSlots'])

    if (props['availableTimeSlots'] !== null) {
      setAvailableTimeSlots(props['availableTimeSlots'])
    }
  }, [refresh])

  return (
    <ScheduleMeeting
      selectedDateDayTitleFormatString="cccc, LLLL do"
      startTimeFormatString="h:mm a"
      scheduleMeetingStyles={styles.meetingScheduler}

      // Language props
      lang_cancelButtonText="Cancel"
      lang_confirmButtonText="Confirm"
      lang_emptyListText="No times available"
      lang_goToNextAvailableDayText="Next Available"
      lang_noFutureTimesText="No future times available"
      lang_selectedButtonText="Selected:"

      borderRadius={10}
      primaryColor='#7FB3D5'
      eventDurationInMinutes={30}
      availableTimeslots={availableTimeSlots}
      onSelectedDayChange={props.handleDaySelect}
      onStartTimeSelect={props.handleStartTimeSelect}

      // eventStartTimeSpreadInMinutes={60}
    />
  );
}